import * as React from 'react';

import CreditModel from 'src/model/credit.model';
import xlsxIcon from '../../../../../assets/xlsxIcon';
import pdfIcon from '../../../../../assets/pdfIcon';
import './CreditsPaymentDetailDesktop.scss';
import Modal from 'src/components/common/Modal/Modal';
import CreditsPaymentDetailsTable from '../CreditsPaymentDetailsTable';
import LocaleFormating from 'src/translation/localeFormating';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';

interface ICreditsPaymentDetailDesktopProps {
  onCloseModal: () => void;
  creditDetails: CreditModel;
  disposeCredit: (databaseId: number, taker: string, note: string) => void;
}

interface ICreditsPaymentDetailDesktopState {
  taker: string;
  note: string;
  showLoader: boolean;
}

const styles = {
  minWidth: '80%',
  minHeight: '80%',
  maxHeight: '90%',
  overflow: 'hidden'
};

class CreditsPaymentDetailDesktop extends React.Component<
  ICreditsPaymentDetailDesktopProps,
  ICreditsPaymentDetailDesktopState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      taker: '',
      note: '',
      showLoader: false
    };
  }

  private handleChangeTaker = (e: any) => {
    const value: any = e.target.value;

    if (
      !value ||
      (value !== ' ' && !startEndWithWhiteSpacesValidation(value))
    ) {
      this.setState({
        taker: value
      });
    }
  };

  private handleChangeNote = (e: any) => {
    const value: any = e.target.value;

    if (
      !value ||
      (value !== ' ' && !startEndWithWhiteSpacesValidation(value))
    ) {
      this.setState({
        note: value
      });
    }
  };

  private submitDisposition = () => {
    const { creditDetails } = this.props;
    this.props.disposeCredit(
      creditDetails.id,
      this.state.taker,
      this.state.note
    );
    this.props.onCloseModal();
  };

  public doExport = (type: string) => {
    const { creditDetails } = this.props;
    if (type === 'pdf') {
      this.setState({ showLoader: true });
      InvoiceService.exportSelectedInvoicesSummary(
        type,
        creditDetails.paymentId,
        0,
        0,
        'admin'
      )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `Payment_Summary.pdf`);
        })
        .catch(error => {
          this.setState({ showLoader: false });
          console.log(error);
        });
    } else if (type === 'xlsx') {
      this.setState({ showLoader: true });
      InvoiceService.exportSelectedInvoicesSummary(
        type,
        creditDetails.paymentId,
        0,
        0,
        'admin'
      )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `Payment_Summary.xlsx`);
        })
        .catch(error => {
          this.setState({ showLoader: false });
          console.log(error);
        });
    }
  };
  public printPdf = () => {
    this.doExport('pdf');
  };
  public printExcel = () => {
    this.doExport('xlsx');
  };
  public render() {
    const { creditDetails } = this.props;
    return (
      <Modal handleCloseModal={this.props.onCloseModal} styles={styles}>
        <div className="section-loader">
          {this.state.showLoader ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            ''
          )}
          <div className="rp-credits-payment-details-desktop">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 d-flex align-items-center justify-content-between">
                  <h3 className="rp-credits-payment-details-desktop-title">
                    Payment Detail
                  </h3>
                  <i
                    className="rpds-close close-modal"
                    onClick={this.props.onCloseModal}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex">
                  <h6 className="rp-credits-payment-detail-payment-id-title">
                    Payment Id:{' '}
                    <span className="rp-credits-payment-detail-payment-id">
                      {creditDetails.paymentId}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="row rp-credits-payment-details-desktop-details">
                <div className="col-6 rp-credits-payment-details-desktop-info">
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Cust code:{' '}
                      <span className="rp-credits-payment-detail-data">
                        {creditDetails.userInformation.clientIdentity}
                      </span>
                    </h6>
                  </div>
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Pmt time:{' '}
                      <span className="rp-credits-payment-detail-data">
                        {LocaleFormating.formatDate(
                          creditDetails.pmtDate,
                          'short'
                        )}
                      </span>
                    </h6>
                  </div>
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Pmt type:{' '}
                      <span className="rp-credits-payment-detail-data text-transform-none">
                        Apply Credits
                      </span>
                    </h6>
                  </div>
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Email:{' '}
                      <span className="rp-credits-payment-detail-data text-transform-none">
                        {creditDetails.userInformation.email}
                      </span>
                    </h6>
                  </div>
                </div>
                <div className="col-6 rp-credits-payment-details-desktop-info">
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Database id:{' '}
                      <span className="rp-credits-payment-detail-data">
                        {creditDetails.id}
                      </span>
                    </h6>
                  </div>
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Signature:{' '}
                      <span className="rp-credits-payment-detail-data text-transform-none">
                        {creditDetails.signature}
                      </span>
                    </h6>
                  </div>
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Taker:
                      {creditDetails.taker ||
                      this.props.creditDetails.paymentStatus !== 'PENDING' ? (
                        <span className="rp-credits-payment-detail-data text-transform-none">
                          {' '}
                          {creditDetails.taker}
                        </span>
                      ) : (
                        <React.Fragment>
                          <span className="required">*</span>{' '}
                          <input
                            className="rp-credits-payment-detail-desktop-input"
                            type="text"
                            value={this.state.taker}
                            onChange={this.handleChangeTaker}
                            required={true}
                          />
                        </React.Fragment>
                      )}
                    </h6>
                  </div>
                  <div className="rp-credits-payment-details-desktop-item">
                    <h6 className="rp-credits-payment-detail-field">
                      Note:
                      {creditDetails.notes ||
                      this.props.creditDetails.paymentStatus !== 'PENDING' ? (
                        <span className="rp-credits-payment-detail-data text-transform-none">
                          {' '}
                          {creditDetails.notes}
                        </span>
                      ) : (
                        <React.Fragment>
                          <span className="required">*</span>{' '}
                          <input
                            className="rp-credits-payment-detail-desktop-input"
                            type="text"
                            value={this.state.note}
                            onChange={this.handleChangeNote}
                          />
                        </React.Fragment>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="rp-divider" />
                </div>
              </div>

              <div className="row rp-credits-payment-detail-disposition-button">
                <div className="col-12 flex-box">
                  <div className="print" onClick={this.printExcel}>
                    <img className="image-icon xlsx-icon" src={xlsxIcon} />
                  </div>
                  <div className="export" onClick={this.printPdf}>
                    <img className="image-icon" src={pdfIcon} />
                  </div>
                  {this.props.creditDetails.paymentStatus === 'PENDING' && (
                    <button
                      className="primary-button rp-disposition-button"
                      onClick={this.submitDisposition}
                      disabled={!this.state.taker || !this.state.note}
                    >
                      Disposition this payment
                    </button>
                  )}
                </div>
              </div>
            </div>
            <CreditsPaymentDetailsTable
              payments={creditDetails.paymentDetails}
              customerCode={creditDetails.userInformation.clientIdentity}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreditsPaymentDetailDesktop;
